import organizer    from './event/organizer'
import period       from './event/period'
import subEvent     from './event/subEvent'
import superEvent   from './event/superEvent'
import workFeatured from './event/workFeatured'
import actor        from './observation/actor'
import attendee     from './observation/attendee'
import authority    from './observation/authority'
import document     from './observation/document'

import moment from 'moment/moment'

import Form from '../../../display/forms/FormElements'

import Place from '../../../things/Place'
import Thing from '../../../things/Thing'
import Word  from '../../../things/Word'

import Method from '../../../net/Method'

import api from '../../../configs/api'

const elements =
[
{
        type       : Form.SEARCH_SELECTOR ,
        path       : api.thesaurus.observations_status,
        clearLabel : 'Vider' ,
        closeLabel : 'Fermer' ,
        init       :
        {
            id         : 'eventStatus',
            key        : 'eventStatus',
            label      : 'Statut de l\'événement',
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            required   : true,
            type       : 'search',
            variant    : 'outlined'
        },
        inputProps :
        {
            label : 'Statut...'
        },
        limit  : 0,
        logics :
        {
            disabledSuggestions : ( props ) =>
            {
                const { rel } = props ;
                let suggestions = [] ;
                if( rel instanceof Thing )
                {
                    const { additionalType } = rel ;
                    if( additionalType instanceof Word )
                    {
                        suggestions.push( additionalType ) ;
                    }
                }
                return suggestions ;
            }
        }
    },
    {
        type         : Form.DATETIME ,
        defaultValue : null ,
        format       : 'L - LT' ,
        init         :
        {
            id              : 'startDate',
            key             : 'startDate',
            ampm            : true,
            autoOk          : true ,
            cancelLabel     : 'Annuler' ,
            clearable       : true ,
            clearLabel      : 'Vider' ,
            disablePast     : false ,
            disableFuture   : false ,
            invalidLabel    : '-',
            inputVariant    : 'outlined' ,
            fullWidth       : true ,
            label           : 'Date de début' ,
            okLabel         : 'OK',
            required        : true,
            showTodayButton : true ,
            todayLabel      : 'Maintenant',
            variant         : 'dialog'
        }
    }
    ,
    {
        type         : Form.DATETIME ,
        defaultValue : null,
        format       : 'L - LT' ,
        minDate      : 'startDate' ,
        init :
        {
            id            : 'endDate',
            key           : 'endDate',
            autoOk        : true ,
            cancelLabel   : 'Annuler' ,
            clearable     : true ,
            clearLabel    : 'Vider' ,
            invalidLabel  : '-',
            inputVariant  : 'outlined' ,
            disableFuture : false ,
            disablePast   : false ,
            label         : 'Date de fin' ,
            fullWidth     : true ,
            okLabel       : 'OK',
            variant       : 'dialog'
        }
    },

    {
        type       : Form.SEARCH_SELECTOR ,
        clazz      : Place,
        path       : api.places.url ,
        clearLabel : 'Vider' ,
        closeLabel : 'Fermer' ,
        init       :
        {
            id         : 'location',
            key        : 'location',
            label      : 'Lieu de l\'événement',
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            required   : true,
            type       : 'search',
            variant    : 'outlined'
        },
        inputProps :
        {
            label : 'Lieu...'
        },
        limit  : 0,
        logics :
        {
            disabledSuggestions : ( props ) =>
            {
                const { rel } = props ;
                let suggestions = [] ;
                if( rel instanceof Thing )
                {
                    const { organization } = rel ;
                    if( organization instanceof Place )
                    {
                        suggestions.push( organization ) ;
                    }
                }
                return suggestions ;
            }
        }
    }
];

const prepare = ( item ) =>
{
    let {
        endDate,
        eventStatus,
        location,
        startDate
    } = item ;

    const object = (
    {
        endDate : endDate instanceof Date
                ? moment(endDate).toISOString()
                : '' ,

        eventStatus : eventStatus instanceof Thing
                    ? String(eventStatus.id)
                    : null ,

        location : location instanceof Thing
                 ? String(location.id)
                 : null,

        startDate : startDate instanceof Date
                  ? moment(startDate).toISOString()
                  : ''

    });
    return object ;
};

const observation =
{
    // -------- dependencies

    actor,
    attendee,
    authority,
    document,
    organizer,
    period,
    subEvent,
    superEvent,
    workFeatured,

    // -------- settings

    datePattern : 'L [à] LTS',
    edit :
    {
        agree       : 'Sauver' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez remplir le formulaire ci-dessous pour modifier cette observation.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...' ,
        method      : Method.PATCH,
        success     : 'Mise à jour réussie!' ,
        title       : 'Modifier l\'observation' ,
        elements,
        prepare
    },
    labels :
    {
        endDate     : 'Date de fin' ,
        empty       : '----' ,
        eventStatus : 'Statut de l\'observation' ,
        location    : 'Lieu de l\'observation',
        name        : 'Nom' ,
        startDate   : 'Date de début' ,
        type        : 'Type de l\'observation'
    },
    title    : 'Observation' ,
    tooltips :
    {
        add    : 'Ajouter',
        edit   : 'Modifier',
        remove : 'Supprimer'
    }
};

export default observation ;
